import PropTypes from 'prop-types'
import React from 'react'

export const Page = ({children, className = 'main-content'}) => (<section className={className}>{children}</section>)

Page.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
}
